import { MbeServiceDTO, OnlineMbePackTypeDto } from "@/model/data.model";

export class AmazonEBaySetupClass {
  ecommerceName: string;
  token: string;
  tenantId: number;
  customerId: number;
  username: string;
  customerEcommerceMbeServices: CustomerEcommerceMbeService[];
  customerEcommerceOrderConfiguration: EcommerceOrderConfiguration;
  mbePackageTypes: OnlineMbePackTypeDto[];
  mbePackageType: OnlineMbePackTypeDto;
  domesticServices: MbeServiceDTO[];
  exportServices: MbeServiceDTO[];
  amazonSellerCode?: string;
  expireDate?: Date;

  constructor(data) {
    this.ecommerceName = data.ecommerceName;
    this.token = "";
    this.tenantId = data.tenantId;
    this.customerId = data.customerId;
    this.username = data.username;
    this.customerEcommerceMbeServices = [];
    this.customerEcommerceOrderConfiguration = {} as EcommerceOrderConfiguration;
    this.mbePackageTypes = [];
    this.mbePackageType = {} as OnlineMbePackTypeDto;
    this.domesticServices = [];
    this.exportServices = [];
    if (this.ecommerceName === "AMAZON") {
      this.amazonSellerCode = "";
    }
    this.expireDate = null;
  }

  getEcommerceMbeServicesPayload() {
    return this.customerEcommerceMbeServices
      .filter(item => item.value)
      .map(item => ({
        tenantId: this.tenantId,
        customerId: this.customerId,
        username: this.username,
        ecommerceName: this.ecommerceName,
        ecommerceCourierServiceName: item.ecommerceCourierServiceName,
        ecommerceCourierServiceBusinessId:
          item.ecommerceCourierServiceBusinessId,
        mbeServiceName: item.value.mbeServiceName,
        mbeServiceBusinessId: item.value.idMBEBusiness,
        idOrderMbeService: item.idOrderMbeService || null
      }));
  }

  getEcommerceOrderConfigurationPayload(packageWeightDimensions) {
    const sellerId = this.amazonSellerCode || null;
    const idOrderConfiguration =
      this.customerEcommerceOrderConfiguration.idOrderConfiguration || null;
    const token = this.token;
    const defaultPackTypeBusinessId = this.mbePackageType.packtypeBusinessId;
    const defaultPackTypeName = this.mbePackageType.packTypeDescription;
    const defaultPackageWeight = this.getPackageWeightDimensionsValue(
      "weight",
      packageWeightDimensions
    );
    const defaultDepth = this.getPackageWeightDimensionsValue(
      "length",
      packageWeightDimensions
    );
    const defaultHeight = this.getPackageWeightDimensionsValue(
      "height",
      packageWeightDimensions
    );
    const defaultWidth = this.getPackageWeightDimensionsValue(
      "width",
      packageWeightDimensions
    );
    const customerOrderConfigurationPayload = {
      tenantId: this.tenantId,
      customerId: this.customerId,
      username: this.username,
      ecommerceName: this.ecommerceName,
      token,
      sellerId,
      defaultPackageWeight,
      defaultDepth,
      defaultHeight,
      defaultWidth,
      defaultPackTypeBusinessId,
      defaultPackTypeName,
      idOrderConfiguration
    };
    return customerOrderConfigurationPayload;
  }

  getPackageWeightDimensionsValue(valueName, packageWeightDimensions) {
    return String(
      packageWeightDimensions.find(item => item.value === valueName)[valueName]
    ).replace(",", ".");
  }
}

interface CustomerEcommerceMbeService {
  customerId: number;
  ecommerceCourierServiceBusinessId: number;
  ecommerceCourierServiceName: string;
  ecommerceName: string;
  idOrderMbeService: number;
  mbeServiceBusinessId: number;
  mbeServiceName: string;
  tenantId: number;
  username: string;
  value?: MbeServiceDTO;
  idEcommerceCourierService?: number;
  macroareaId?: number;
  macroareaName?: string;
}

interface EcommerceOrderConfiguration {
  customerId: number;
  defaultDepth: number;
  defaultHeight: number;
  defaultPackTypeBusinessId: number;
  defaultPackTypeName: string;
  defaultPackageWeight: number;
  defaultWidth: number;
  ecommerceName: string;
  idOrderConfiguration: number;
  tenantId: number;
  token: string;
  username: string;
}
